import React from 'react';

/** Burglar in a flat cap and domino mask, drawn to match the other sidebar icons. */
export const ThiefIcon: React.FC = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.8 8C7.4 5.2 9.5 3.4 12.3 3.4C14.9 3.4 16.9 5 17.5 7.4H20.6M6.8 8H17.6M7 15.6C7.8 17.4 9.7 18.6 12 18.6C14.3 18.6 16.2 17.4 17 15.6M4 22C4.7 19.9 8 18.6 12 18.6C16 18.6 19.3 19.9 20 22"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.4 11.6C4.5 10.5 6.2 10.3 8 10.6C9.4 10.8 10.7 11.3 12 11.3C13.3 11.3 14.6 10.8 16 10.6C17.8 10.3 19.5 10.5 20.6 11.6C20 13.5 18.4 14.7 16.4 14.7C14.7 14.7 13.4 13.7 12 13.7C10.6 13.7 9.3 14.7 7.6 14.7C5.6 14.7 4 13.5 3.4 11.6ZM6.8 12.4A1.6 1 0 1 0 10 12.4A1.6 1 0 1 0 6.8 12.4ZM14 12.4A1.6 1 0 1 0 17.2 12.4A1.6 1 0 1 0 14 12.4Z"
			fill="currentColor"
		/>
	</svg>
);
